import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

export const useSaveAllApprovers = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ data, updatedBy }: { data: Record<string, string[]>; updatedBy: string }) => {
      await axios.post(`${baseUrl}/aws/approvers/save-multiple`, {
        data,
        updatedBy,
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['globalApprovers'] })
    },
  })
}
